<template>
  <div class="followup" >
    <div class="followup--header">
      <div class="followup--header--title">
        <div class="title--back iconfont" @click="$router.push('/homeassets')">&#xe600;</div>
        <div class="title--desc">资产检查记录</div>
        <div class="title--add iconfont" ></div>
      </div>
      <div class="market--search--layer">
        <div class="search--header">
          <input type="text" placeholder="请输入资产名称或检查人" class="search--header--ipt" v-model="selectvalue">
          <div class="search--header--icon iconfont" @click="handleToFilterAssetsCheck">&#xe605;</div>
        </div>
      </div>
    </div>
    <div class="followup--line"></div>
    <div class="followup--info" v-if="hisAssetsCheckList.length >0" >
      <div
        class="followup--info--item"
        v-for="item in hisAssetsCheckList"
        :key="item.id"
        @click="handleToAssetsCheckDetail(item)"
      >
        <div class="item--title">
          <div class="title--desc">{{item.assetName}}</div>
          <div class="title--status">{{item.approveStatusName}}</div>
        </div>
        <div class="item--addr">
          <div class="title--time">{{item.inputDate | getMonDay}}</div>
          <div class="title--addr" >{{item.assetLocation}}</div>
        </div>
        <div class="item--desc">{{item.remark}}</div>
        <div
          class="item--swiper"
          v-if="item.docEReceiveList.length > 0"
        >
          <swiper class="echw-fb-swiper" :options="swiperOption">
            <swiper-slide
              class="echw-fb-swiper-slide"
              v-for="(imgItem,imgIndex) in item.docEReceiveList"
              :key="imgItem.pk"
            >
              <img @click.stop="handleToFollowupDetailImg(item.docEReceiveList,imgIndex)" class="swiper--img" :src="imgItem.downloadUrl" alt="">
            </swiper-slide>
            <div v-if="false" class="swiper-pagination"  slot="pagination"></div>
          </swiper>
        </div>
        <div class="item--follow">
          <div class="item--follow--person">检查人:{{item.actornames}}</div>
        </div>
      </div>
    </div>
    <div class="followup--info" v-else>
      <van-empty description="暂无数据" />
    </div>
    <div class="follow--big--img">
      <div class="md-example-child md-example-child-image-reader">
        <md-image-viewer
          v-model="imgShow"
          :list="imgurlList"
          :has-dots="true"
          :initial-index="imgIndex">
        </md-image-viewer>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import { get } from '../api/api'
import { ImageViewer } from 'mand-mobile'

export default {
  name: 'HisAssets',
  components: {
    [ImageViewer.name]: ImageViewer
  },
  data () {
    return {
      swiperOption: {
        centeredSlides: false, // 当前slide居中显示
        slidesPerView: 3, // 1是显示1个banner, 'auto'自适应
        spaceBetween: 12, // slide间隔（px）
        loop: false,
        autoplay: false,
        delay: 5000, // 自动轮播， 默认 3000 ms
        simulateTouch: true, // 鼠标拖拽
        allowTouchMove: true, // 触摸滑动
        lazyLoading: true,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true
        }
      },
      scrollNum: 0, // 滑动到底部提前控制触发的数值
      scrollFlag: true, // 控制滑动pageNum在没有返回值的时候不能加1
      pageNum: 1, // 列表页码
      pageSize: 10, // 列表条数
      selectvalue: '', // 资产检查过滤条件
      hisAssetsCheckList: [], // 历史资产检查列表
      imgurlList: [], // 控制图片全屏显示
      imgShow: false, // 控制图片全屏显示
      imgIndex: 0, // 控制图片全屏显示
      apiFlag: true // 控制接口不用重复调用
    }
  },
  beforeMount () {
    this.getHisAssetsCheckList()
  },
  mounted () {
    // const followContentElement = document.body
    window.addEventListener('scroll', this.handleToFollowupListScroll, true)
  },
  destroyed () {
    // const followContentElement = document.body
    window.removeEventListener('scroll', this.handleToFollowupListScroll, true)
  },
  methods: {
    // 获取历史资产检查列表
    async getHisAssetsCheckList () {
      if (this.apiFlag) {
        this.apiFlag = false
        const result = await get('/api/CBMS-APP/mmassetcheck/list', {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          selectvalue: this.selectvalue
        })
        if (result.success) {
          if (this.hisAssetsCheckList.length !== 0 && result.data.length === 0) {
            this.$toast.success('数据已全部加载')
          } else {
            this.hisAssetsCheckList = this.hisAssetsCheckList.concat(result.data)
            this.pageNum = this.pageNum + 1
            this.apiFlag = true
          }
        } else {
          this.$toast.success('获取数据报错')
        }
      }
    },
    // 过滤历史资产检查列表
    async handleToFilterAssetsCheck () {
      this.pageNum = 1
      this.hisAssetsCheckList = []
      await this.getHisAssetsCheckList()
    },
    // 查看资产详情
    handleToAssetsCheckDetail (data) {
      if (data.approveStatus === '000' || data.approveStatus === '992') {
        this.$router.push({ name: 'addcheck', params: { data, routerTag: 'hisassets' } })
      } else {
        this.$router.push({ name: 'verifydetail', params: { data, routerTag: 'hisassets' } })
      }
    },
    // 滑动到手机底部触发的函数
    async handleToFollowupListScroll (e) {
      // 变量scrollTop是滚动条滚动时，距离顶部的距离
      var scrollTop = e.target.scrollTop
      // 变量windowHeight是可视区的高度
      var windowHeight = e.target.clientHeight
      // 变量scrollHeight是滚动条的总高度
      var scrollHeight = e.target.scrollHeight
      // 滚动条到底部的条件
      if (scrollTop + windowHeight + this.scrollNum >= scrollHeight) {
        await this.getHisAssetsCheckList()
      }
    },
    // 点击轮播上图片触发的函数
    handleToFollowupDetailImg (imgList, imgIndex) {
      // this.imgurlList = []
      // this.imgIndex = 0
      imgList.forEach(item => {
        this.imgurlList.push(item.downloadUrl)
      })
      this.imgIndex = imgIndex
      this.imgShow = true
    }
  },
  filters: {
    getMonDay (time) {
      return time.split(' ')[0].split('-').slice(1).join('-')
    }
  },
  watch: {
    imgShow (newVal, oldVal) {
      if (!newVal) {
        this.imgurlList = []
        this.imgIndex = 0
      }
    }
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.followup
  position : relative
  width : 100vw
  height : 100vh
  overflow-x : hidden
  background-color : #ffffff
  overflow-y : scroll
  &.active
    padding-bottom : 64px
  .followup--header
    position : fixed
    top:0
    left :0
    width : 100%
    z-index : 10
    .followup--header--title
      display : flex
      align-items : center
      background :#687591
      font-family: MyriadPro-Regular
      font-size: 38px
      font-weight: normal
      font-stretch: normal
      color: #ffffff
      .title--back
        font-size: 38px
        width : 100px
        padding : 16px 0 16px 16px
      .title--add
        width : 100px
        font-size: 38px
        padding : 16px 16px 16px 0
        text-align : right
      .title--desc
        flex : 1
        padding : 16px 0
        text-align : center
    .followup--header--filter
      display : flex
      justify-content : center
      align-items : center
      background-color : #ffffff
      border-bottom : 1px solid #f7f7f7
      .filter--time
        flex : 1
        padding : 19px 0
        text-align : center
        font-family: MyriadPro-Regular
        font-size: 32px
        font-weight: normal
        font-stretch: normal
        color: #333333
        border-right : 1px solid #f7f7f7
        span
          padding-left : 16px
      .filter--type
        border-left : 1px solid #f7f7f7
    .followup--header--desc
      padding : 16px
      box-sizing : border-box
      border-bottom : 1px solid #b6b5b5
      background-color : #ffffff
      .header--desc--card
        display : flex
        align-items : center
        .desc--text
          flex : 1
          font-family: MyriadPro-Regular
          font-size: 26px
          font-weight: normal
          font-stretch: normal
          color: #333333
          overflow : hidden
          .desc--address
            width : 100%
            color : #ecbd62
            overflow: hidden
            text-overflow: ellipsis
            white-space: nowrap
          .desc--status
            margin-top : 8px
            font-size : 34px
            color : #ecbd62
        .desc--icon
          width : 80px
          text-align : right
          color : #ecbd62
      &>>>.van-swipe__indicators
        bottom : 0
      &>>>.van-swipe__indicator
        background-color : #a6a1a1
    .viewmarket--header--empty
      padding : 36px 16px
      box-sizing : border-box
      border-bottom : 1px solid #b6b5b5
      background-color : #ffffff
      text-align : center
      font-family: MyriadPro-Regular
      font-size: 28px
      font-weight: normal
      font-stretch: normal
      color: #b6b5b5
    .market--search--layer
      .search--header
        padding : 16px 16px 0 16px
        display : flex
        background-color : #faf9f9
        font-family: MyriadPro-Regular
        font-size: 34px
        font-weight: normal
        font-stretch: normal
        color : #4282e1
        .search--header--ipt
          padding : 16px 0 16px 16px
          flex : 1
          height : 34px
          outline: none
          -webkit-appearance: none
          border-radius:0
          border-top : 1px solid #8e8c8c
          border-bottom : 1px solid #8e8c8c
          border-left :  1px solid #8e8c8c
          border-right :  1px solid #8e8c8c
          border-top-left-radius : 12px
          border-bottom-left-radius : 12px
        .search--header--icon
          width : 100px
          height : 34px
          background-color : #faf9f9
          text-align : center
          padding : 16px 16px 16px 16px
          font-size: 34px
          border-top : 1px solid #8e8c8c
          border-bottom : 1px solid #8e8c8c
          border-right :  1px solid #8e8c8c
          border-left :  1px solid #8e8c8c
          border-top-right-radius : 12px
          border-bottom-right-radius : 12px
  .followup--line
    width : 100%
    height: 166px
  .followup--info
    padding-bottom : 64px
    .followup--info--item
      margin : 16px 16px 0 16px
      padding : 0 16px
      border-radius : 16px
      background-color : #f7f7f7
      .item--addr
        display : flex
        align-items : center
        padding-bottom : 8px
        font-size: 28px
        font-weight: normal
        font-stretch: normal
        color: #7186d3
        .title--time
          width : 120px
        .title--addr
          text-overflow:ellipsis
          overflow:hidden
          white-space:nowrap
      .item--title
        padding-top : 16px
        display : flex
        justify-content : center
        align-items : center
        font-size: 32px
        font-weight: normal
        font-stretch: normal
        color: #333333
        .title--desc
          flex : 1
          padding : 4px 0
          color : #7186d3
        .title--status
          font-size: 28px
          border : 1px solid #a6a1a1
          padding : 4px 8px
          width : 140px
          text-align : center
          border-radius : 12px
      .title--time
        padding : 8px 0
        font-size: 32px
        font-weight: normal
        font-stretch: normal
        color: #7186d3
      .item--desc
        padding : 8px 0
        line-height : 38px
        font-size: 32px
        font-weight: normal
        font-stretch: normal
        color: #333333
      .item--swiper
        padding : 16px
        height : 210px
        .echw-fb-swiper
          width : 100%
          height : 210px
          .echw-fb-swiper-slide
            height : 210px
            img
              width : 100%
              height : 100%
      .item--follow
        display : flex
        justify-content : center
        align-items : center
        font-size: 32px
        font-weight: normal
        font-stretch: normal
        color: #333333
        .item--follow--person
          flex : 1
          padding : 16px 0
          font-size: 28px
          text-align : right
</style>
